import { isChatChannel } from "../channels/types";
import type { FollowUpChannelWithData } from "./reducer/schema";

export function isChatChannelWithData(
  channel: FollowUpChannelWithData,
): channel is Extract<FollowUpChannelWithData, { channel: "slack" | "teams" }> {
  return isChatChannel(channel.channel);
}

export function isEmailChannelWithData(
  channel: FollowUpChannelWithData,
): channel is Extract<FollowUpChannelWithData, { channel: "work_email" | "personal_email" }> {
  return channel.channel === "work_email" || channel.channel === "personal_email";
}
